<figure [attr.id]="id"></figure>
